import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

/**
 * @interface
 */
const Props = {
  children: PropTypes.string.isRequired,
  size: PropTypes.string,
  fillColor: PropTypes.string,
  weight: PropTypes.string,
  marginBottom: PropTypes.number,
  mobileCentered: PropTypes.bool,
};

const DefaultProps = {
  size: undefined,
  fillColor: undefined,
  weight: undefined,
  marginBottom: undefined,
  mobileCentered: false,
};

/**
 * Generic text component
 * @param {Props} props
 */
export default function Text({
  children,
  size,
  fillColor,
  weight,
  marginBottom,
  mobileCentered,
  typographyProps,
}) {
  return (
    <Container
      size={size}
      fillColor={fillColor}
      weight={weight}
      marginBottom={marginBottom}
      mobileCentered={mobileCentered}
      {...typographyProps}
    >
      {children}
    </Container>
  );
}

Text.propTypes = Props;
Text.defaultProps = DefaultProps;
